import AlwaysEditableField from "components/InlineEditableField/AlwaysEditableField";
import UiTypography from "components/base/UiTypography";
import { ReactNode } from "react";
import UiBox from "components/MDBox";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import { parseCurrencyInput } from "./useInlineFinancialEdits";
import { validateCurrency, validatePercentage } from "modules/proposals/validators";

type EditableFinancialCellProps = {
  value: string;
  onSave: (value: string) => Promise<string | void>;
  disabled?: boolean;
  kind?: "currency" | "percentage";
};

type ReadOnlyFinancialCellProps = {
  cents: number | null | undefined;
};

export function ReadOnlyFinancialCell({ cents }: ReadOnlyFinancialCellProps) {
  return (
    <UiBox px="4px">
      <UiTypography uiVariant="body-sm" sx={{ textAlign: "right", px: "4px" }}>
        {formatCentsToUSD(cents)}
      </UiTypography>
    </UiBox>
  );
}

export default function EditableFinancialCell({
  value,
  onSave,
  disabled,
  kind = "currency",
}: EditableFinancialCellProps) {
  const content: ReactNode =
    kind === "currency" ? (
      <AlwaysEditableField
        value={value}
        onSave={onSave}
        formatDisplay={(display) => formatCentsToUSD(parseFloat(display) * 100)}
        parseInput={parseCurrencyInput}
        validate={validateCurrency}
        type="currency"
        disabled={disabled}
        fontSize="12px"
      />
    ) : (
      <AlwaysEditableField
        value={value}
        onSave={onSave}
        formatDisplay={(display) => `${display}%`}
        validate={validatePercentage}
        type="percentage"
        disabled={disabled}
        fontSize="12px"
      />
    );

  return <UiBox px="4px">{content}</UiBox>;
}
